import React from 'react';
import { Link } from 'react-router-dom';
import { BASE_URL } from '../constant';
import styles from '../sass/home.module.scss'; // Assuming some styles might be reused or adapted
import { useDispatch } from 'react-redux';
import { removeFavourite } from '../redux/actions/favouriteActions';
import { toast } from 'react-toastify';
import { listFavourite } from '../redux/actions/favouriteActions';


const ProductCard = ({ product, onRemoveFavourite, showPrice = true }) => {
    // Function to calculate the discount percentage
    const getDiscountPercentage = (regularPrice, salePrice) => {
        if (regularPrice && salePrice && regularPrice > salePrice) {
            return ((regularPrice - salePrice) / regularPrice) * 100;
        }
        return 0;
    };

    // Function to get the lowest sale price from the pro_var array
    const getLowestSalePrice = (pro_var) => {
        if (pro_var && pro_var.length > 0) {
            const prices = pro_var.map((variant) => parseFloat(variant.sale_price));
            const lowestPrice = Math.min(...prices);
            return lowestPrice;
        }
        return null;
    };

    const discount = getDiscountPercentage(product.regular_price, product.sale_price);
    const lowestPrice = getLowestSalePrice(product.pro_var);

    const dispatch = useDispatch();

    const handleRemoveFavourite = (productId) => {
        const isConfirmed = window.confirm('Are you sure you want to remove this product from favourites?');

        if (isConfirmed) {
            dispatch(removeFavourite(productId))
                .unwrap()
                .then(() => {
                    toast.info('Product removed from favourites!');
                    dispatch(listFavourite()); // Refresh the list
                })
                .catch((err) => {
                    toast.error('Failed to remove product from favourites.');
                    console.error('Error:', err);
                });
        }
    };

    return (
        <div className={`product_card ${styles.productItem}`}>
            <Link to={`/product/${product.slug}`}>
                <div className={`product_thumbnail_box`}>
                    <img src={`${BASE_URL}${product.thumbnail}`} alt={product.name} className={styles.brandThumbnail} />
                </div>

                <div className='product_card_details'>
                    <div className='productCard_title'>{product.title}</div>
                    {showPrice && (
                        <div className='productCard_price_wrapper'>
                            {lowestPrice !== null ? (
                                <span className='price_regular'>Starting @ <span className='price_sale'>₹{lowestPrice}</span></span>
                            ) : product.sale_price ? (
                                <>
                                    <div className='priceRow'>
                                        <span className='price_regular'>MRP </span> <span className='price_regular strike'>₹{product.regular_price}</span>
                                    </div>
                                    <div className='priceRow'>
                                        <span className='price_sale'>₹{product.sale_price}</span> <span className='price_discount'>({discount.toFixed(0)}%{"\n"}OFF)</span>
                                    </div>
                                </>
                            ) : (
                                <span style={styles.productPrice}>₹{product.regular_price}</span>
                            )}
                        </div>
                    )}
                </div>
            </Link>
            {onRemoveFavourite && (
                <div className='product_actions'>
                    <button
                        className='remove_button'
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleRemoveFavourite(product.id);
                        }}
                        title="Remove from favourites"
                    >
                        Remove
                    </button>
                </div>
            )}
        </div>
    );
};

export default ProductCard;
